var profileValidator = require('./../validation');
var utils = require('src/creative/pricing-lead-form/utils');

function init(firebase) {
    var forgotPasswordDrawerSelector = '#forgot-password-drawer';
    var forgotPasswordDrawer = $(forgotPasswordDrawerSelector);
    var forgotPasswordForm = forgotPasswordDrawer.find('#forgot-password-form');
    var formErrorSelector = '#forgot-password-form-error';
    var forgotPasswordDrawerDone = $('#forgot-password-drawer-done');

    forgotPasswordForm.on('submit', function(e) {
        e.preventDefault();
        var form = e.target;
        if (profileValidator.isFormValid(forgotPasswordForm)) {
            return firebase.auth().sendPasswordResetEmail(form.email.value).then(function() {
                forgotPasswordDrawerDone.find('#email-reset-info').text(form.email.value);
                utils.switchToDrawer(forgotPasswordDrawerSelector, '#forgot-password-drawer-done');
            }).catch(function(error) {
                profileValidator.parseFirebaseError(error, formErrorSelector);
            });
        }
    });

    forgotPasswordForm.on('blur', 'input', function(e) {
        var input = e.target;
        profileValidator.validateField(forgotPasswordForm, input, formErrorSelector);
    });
}

module.exports = {
    init: init
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/profile/forgot-password/forgot-password-drawer.js
// module id = 78
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14